// extracted by mini-css-extract-plugin
export default {"searchDiv":"search_searchDiv__BrGmM","searchIcon":"search_searchIcon__m5JeM"};